import { actions } from './slice';
import { getECGCapture, getPatientsECG, getFacilitiesEcg } from './actions';

const allActions = {
  ...actions,
  getECGCapture,
  getPatientsECG,
  getFacilitiesEcg,
};

export { allActions as ECGActions };
export { reducer as ECGReducer } from './slice';
